import React from "react";
import classNames from "classnames";
import InfoButton from "./InfoButton";

export default function (props) {
  const className = props.className;

  return (
    <div className={classNames("form-item", { [className]: !!className })}>
      <div className="form-item__label">
        {props.info && <InfoButton marginBottom={10}>{props.info}</InfoButton>}
        <p className="form-item__title">{props.title}</p>
      </div>
      <div className="form-item__field">
        <input
          type={props.type}
          placeholder={props.placeholder}
          required={props.required}
          name={props.name}
          value={props.value}
          onChange={props.setValue || null}
          min={props.min}
          pattern={props.pattern}
          className={classNames("form-item__input", { filled: !!props.value })}
        />
      </div>
    </div>
  );
}
